class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    document.querySelectorAll('[id*="cart-icon-bubble"]').forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
    document.body.classList.add('overflow-hidden');   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.body.style.paddingRight = '';
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if(sectionElement){
        sectionElement.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
        if(section.id == 'cart-free-delivery' && document.querySelector('#product-page-free-delivery')){
          document.querySelector('#product-page-free-delivery').innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  renderRecommendations(html) {
    const currentRecommendations = this.querySelector('#CartDrawer-Recommendations');
    const newRecommendations = this.getSectionDOM(html, '#CartDrawer-Recommendations');

    if (currentRecommendations && newRecommendations) {
      currentRecommendations.replaceWith(newRecommendations);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-icon-bubble--mobile'
      },
      {
        id: 'cart-free-delivery'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.shopify-section');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.renderRecommendations(recommendations.innerHTML);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  renderRecommendations(html) {
    const desktopContent = this.querySelector('[data-cart-drawer-recommendations-desktop]');
    const mobileContent = this.querySelector('[data-cart-drawer-recommendations-mobile]');
    const trigger = this.querySelector('.cart-drawer__recommendations-trigger');
    const overlay = this.querySelector('.cart-drawer__recommendations-overlay');
    const close = this.querySelector('.cart-drawer__recommendations-close');

    if (desktopContent) {
      this.renderContent(desktopContent, html, 'desktop');
    }

    if (mobileContent) {
      this.renderContent(mobileContent, html, 'mobile');
    }

    this.classList.add('has-recommendations');

    if (trigger && overlay) {
      trigger.hidden = false;
      trigger.addEventListener('click', () => this.openPopup(trigger, overlay));
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) this.closePopup(trigger, overlay);
      });
    }

    if (close && overlay && trigger) {
      close.addEventListener('click', () => this.closePopup(trigger, overlay));
    }
  }

  renderContent(container, html, suffix) {
    container.innerHTML = html;
    container.querySelectorAll('form[id]').forEach((form, index) => {
      form.setAttribute('id', `${form.getAttribute('id')}-${suffix}-${index}`);
    });
  }

  openPopup(trigger, overlay) {
    overlay.hidden = false;
    requestAnimationFrame(() => {
      this.classList.add('is-open');
    });
    trigger.setAttribute('aria-expanded', 'true');
  }

  closePopup(trigger, overlay) {
    this.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');

    overlay.addEventListener('transitionend', (event) => {
      if (event.target !== overlay) return;
      overlay.hidden = true;
    }, { once: true });
  }
}

customElements.define('cart-drawer-recommendations', CartDrawerRecommendations);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
